import React, { useState, useContext } from 'react';
import { AuthContext } from '../../../../utils/contextapi/AuthProvider';
import styles from './EditModal.delete.module.css'; // 기존 모달 스타일 재사용 또는 새 파일 생성
import axios from "../../../../utils/api/axios";
// import { DialogEnum, showDialog } from '../../../../utils/dialog/Dialog';
import { IAM_SERVER_TENANT, IAM_SERVER_UNIFIEDPROFILE } from '../../../../utils/Config';
import { getCookie } from '../../../../utils/cookies/cookies';
import { InnocodeButton, useDialog } from '@intsoft/innocode-core';

function DeleteAccountsModal({ onClose, user, doLogout }) {
  const { showDialog } = useDialog();
  const [step, setStep] = useState('verify'); // 'verify', 'warn', 'delete'
  const [currentPw, setCurrentPw] = useState('');
  const [consentChecked1, setConsentChecked1] = useState(false);
  const [consentChecked2, setConsentChecked2] = useState(false);

  // 비밀번호 검증 함수
  const verifyPassword = async () => {
    const userId = getCookie("user_id");
    if (!currentPw) {
      showDialog({
        iconType: "warning",
        type: 'error',
        title: "경고",
        message: "비밀번호를 입력해주세요.",
        confirmText: "확인",
      });
      return;
    }

    try {
      const res = await axios.post(`${IAM_SERVER_UNIFIEDPROFILE}/verify/password`, {
        password: currentPw,
        unifiedProfileId: userId
      });

      const data = res.data;
      if (data.code === 200 || data.success === true) {
        setStep('warn');
      } else {
        showDialog({
          iconType: "warning",
          type: 'error',
          title: "경고",
          message: data.resultMessage || "현재 비밀번호가 일치하지 않습니다.",
          confirmText: "확인",
        });
        // showDialog(DialogEnum.DEFAULT, "실패", data.resultMessage || "현재 비밀번호가 일치하지 않습니다.");
      }
    } catch (err) {
      console.error("비밀번호 검증 오류", err);
      showDialog({
        iconType: "warning",
        type: 'error',
        title: "경고",
        message: "서버 오류가 발생했습니다.",
        confirmText: "확인",
      });
      // showDialog(DialogEnum.DEFAULT, "오류", "서버 오류가 발생했습니다.");
    }
  };

  // 소유 중인 테넌트 확인 함수
  const checkTenants = async (userId) => {
    try {
      const url = `${IAM_SERVER_TENANT}/exist-tenant/${userId}`;
      const res = await axios.get(url);
      const { data } = res.data;
      return data;
    } catch (err) {
      console.error("테넌트 존재 여부 확인 오류", err);
      showDialog({
        iconType: "warning",
        type: 'error',
        title: "경고",
        message: "테넌트 정보를 불러오는 데 실패했습니다.",
        confirmText: "확인",
      });
      // showDialog(DialogEnum.DEFAULT, "오류", "테넌트 정보를 불러오는 데 실패했습니다.");
      return false;
    }
  }

  // 계정 삭제 함수
  const handleDeleteAccount = async () => {
    const userId = getCookie("user_id");

    if (!consentChecked1 || !consentChecked2) {
      showDialog({
        iconType: "warning",
        type: 'error',
        title: "경고",
        message: "모든 동의 사항에 체크해야 합니다.",
        confirmText: "확인",
      });
      // showDialog(DialogEnum.DEFAULT, "경고", "모든 동의 사항에 체크해야 합니다.");
      return;
    }

    // 소유 중인 테넌트가 하나라도 있다면 삭제 불가능
    const hasTenants = await checkTenants(userId);
    if (hasTenants) {
      showDialog({
        iconType: "warning",
        type: 'error',
        title: "경고",
        message: "소유 중인 테넌트가 있습니다. \n계정 삭제를 하려면 먼저 테넌트 소유권을\n다른 사용자에게 이전해야 합니다.",
        confirmText: "확인",
      });
      // showDialog(DialogEnum.DEFAULT, "알림", "소유 중인 테넌트가 있습니다. 계정 삭제를 하려면 먼저 소유권을 다른 사용자에게 이전해야 합니다.");
      onClose();
      return;
    }

    showDialog({
      iconType: "warning",
      type: 'error',
      title: "경고",
      message: "정말로 계정을 삭제하시겠습니까?\n이 작업은 되돌릴 수 없습니다.",
      confirmText: "확인",
      onConfirm: async () => {
        try {
          const res = await axios.post(`${IAM_SERVER_UNIFIEDPROFILE}/delete-account/${userId}`);
          const data = res.data;

          if (data.code === 200 || data.success === true) {
            showDialog({
              iconType: "check",
              type: 'info',
              title: "성공",
              message: "계정이 성공적으로 삭제되었습니다.\n로그인 페이지로 이동합니다.",
              confirmText: "확인",
              onConfirm: () => {
                doLogout();
                onClose();
                window.location.href = '/logout';
              }
            });
            // showDialog(DialogEnum.DEFAULT, "성공", "계정이 성공적으로 삭제되었습니다.");
            // TODO: 로그아웃 또는 메인 페이지로 리디렉션 로직 추가
            // 
            doLogout();
            onClose();
          } else {
            showDialog({
              iconType: "warning",
              type: 'error',
              title: "실패",
              message: data.resultMessage || "계정 삭제에 실패했습니다.",
              confirmText: "확인",
            });
            // showDialog(DialogEnum.DEFAULT, "실패", data.resultMessage || "계정 삭제에 실패했습니다.");
          }
        } catch (err) {
          console.error("계정 삭제 오류", err);
          showDialog({
            iconType: "warning",
            type: 'error',
            title: "실패",
            message: err.response?.data?.resultMessage || "계정 삭제에 실패했습니다.",
            confirmText: "확인",
          });
          // showDialog(DialogEnum.DEFAULT, "오류", "계정 삭제 중 오류가 발생했습니다."); 
        }
      }
    });
    // showDialog(DialogEnum.CONFIRM, "계정 삭제", "정말로 계정을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.", async () => {

    // });
  };

  const deletedItems = [
    { title: "프로필", description: "이름, 사진, 연락처 등 프로필 정보와 설정이 삭제됩니다." },
    { title: "테넌트", description: "테넌트와 관련된 모든 정보가 삭제됩니다." },
    // { title: "Zentry Pay", description: "결제 내역, 결제 수단 등 Zentry Pay 관련 데이터가 모두 삭제됩니다." },
    { title: "가입 서비스", description: "Zentry 계정으로 가입한 모든 서비스의 데이터가 삭제됩니다." },
  ];

  const allConsentsChecked = consentChecked1 && consentChecked2;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          {/* <svg className={styles.backArrow} onClick={onClose} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg> */}
          <div></div>
          <h1 className={`innocode-typography--headline-md innocode-typography--bold ${styles.modalTitle}`}>
            계정 삭제 </h1>
          {/* <h3 className={styles.modalTitle}>계정 삭제</h3> */}
          <InnocodeButton
            theme={"opacity"}
            designType='assistive'
            enablePadding={false}
            iconOnly={true}
            icon={<svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18 17.94 6M18 18 6.06 6" />
            </svg>
            }
            onClick={onClose}
          />
        </div>

        {step === 'verify' && (
          <>
            <div className={styles.modalBody}>
              <p className={styles.modalDescription}>계정 삭제를 진행하려면 현재 비밀번호를 입력해주세요.</p>
              <input
                className={styles.modalInput}
                type="password"
                value={currentPw}
                onChange={(e) => setCurrentPw(e.target.value)}
                placeholder="현재 비밀번호 입력"
              />
            </div>
            <div className={styles.modalFooter}>
              <div className={styles.modalButtonRow}>
                <InnocodeButton
                  designType="assistive"
                  theme="solid"
                  onClick={onClose}>
                  취소
                </InnocodeButton>
                <InnocodeButton
                  onClick={verifyPassword} >
                  확인
                </InnocodeButton>

                {/* <button className={styles.cancelBtn} onClick={onClose}>취소</button>
                <button className={styles.saveBtn} onClick={verifyPassword}>확인</button> */}
              </div>
            </div>
          </>
        )}

        {step === 'warn' && (
          <>
            <div className={styles.modalBody}>
              <p className={styles.infoText}>중요한 내용이므로 주의 깊게 읽어주세요.</p>
              <div className={styles.warningSection}>
                <p>Zentry 계정 삭제는 되돌릴 수 없으며, 모든 데이터가 영구적으로 삭제됩니다. 삭제 후에는 해당 계정으로 서비스를 더 이상 이용할 수 없습니다.</p>
                <p className={styles.userEmail}>
                  삭제될 계정: <span className={styles.userEmailValue}>{user.email || '사용자 정보 없음'}</span>
                </p>
              </div>

              <p className={styles.infoText}>다음 콘텐츠가 모두 삭제됩니다.</p>
              <div className={styles.deletedContentSection}>
                {deletedItems.map((item, index) => (
                  <div key={index} className={styles.deletedItem}>
                    <div className={styles.itemIcon}>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24px" height="24px"><path d="M0 0h24v24H0z" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" /></svg>
                    </div>
                    <div className={styles.itemText}>
                      <h4 className={styles.itemTitle}>{item.title}</h4>
                      <p className={styles.itemDescription}>{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className={styles.modalFooter}>
              <div className={styles.consentCheckboxGroup}>
                <label className={styles.consentLabel}>
                  <input
                    type="checkbox"
                    checked={consentChecked1}
                    onChange={(e) => setConsentChecked1(e.target.checked)}
                  />
                  <span>
                    예, 본인은 모든 미결 금융 거래로 인해 발생하는 청구 금액에 대해 전적으로 책임이 있음을 인지하며, 특정한 상황에서는 수익금을 지급받을 수 없다는 사실을 이해합니다.
                  </span>
                </label>
                <label className={styles.consentLabel}>
                  <input
                    type="checkbox"
                    checked={consentChecked2}
                    onChange={(e) => setConsentChecked2(e.target.checked)}
                  />
                  <span>
                    예, 이 계정과 모든 데이터를 완전히 삭제하고자 합니다.
                  </span>
                </label>
              </div>
              <div className={styles.modalButtonRow}>
                <InnocodeButton
                  designType="assistive"
                  theme="solid"
                  onClick={onClose}>
                  취소
                </InnocodeButton>
                <InnocodeButton
                  backgroundColor=' var(--status-negative, #f83a3a)'
                  onClick={handleDeleteAccount}
                  disabled={!allConsentsChecked}>
                  계정 삭제
                </InnocodeButton>
                {/* <button className={styles.cancelBtn} onClick={onClose}>취소</button>
                <button
                  className={`${styles.deleteBtn} ${!allConsentsChecked ? styles.disabledBtn : ''}`}
                  onClick={handleDeleteAccount}
                  disabled={!allConsentsChecked}
                >
                  계정 삭제
                </button> */}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default DeleteAccountsModal;
